app.controller("ChangeImageController", ["$scope", "$state", "$http", "$uibModal", "fileReader", "AuthService", "$uibModalInstance", "toastr",
    function ($scope, $state, $http, $uibModal, fileReader, AuthService, $uibModalInstance, toastr) {

        $scope.disabled = false;

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        $scope.uploadImage = function (files) {
            $scope.image = files[0];
            $scope.fileName = $scope.image.name;
            fileReader.readAsDataUrl($scope.image, $scope).then(function (src) {
                $scope.imageSrc = src;
            })
        };

        $scope.changeImage = function () {
            if ($scope.image) {
                var fd = new FormData();
                $scope.disabled = true;
                fd.append('image', $scope.image);
                $http.post('/file/image/change', fd, {
                    headers: {'Content-Type': undefined}
                }).then(function (response) {
                    toastr.success('პროფილის სურათის შეცვლაზე განაცხადი შეტანილია');
                    $uibModalInstance.close();
                    $scope.disabled = false;
                })
            }
        };
    }
]);